import { blackColors, grayColor, whiteColor, hexToRgb, blackColor } from 'assets/jss/material-dashboard-pro-react';

const customDialogStyle = (theme) => ({
	dialog: (props) => ({
		'& .MuiPaper-root': {
			marginLeft: '10px',
			marginRight: '10px',
			width: `${props.width || 536}px`,
			maxWidth: '100%',
			[theme.browser.IE]: {
				overflowX: 'hidden',
			},
		},
	}),
	dialogHeader: ({ isNewDashBoardEnabled }) => ({
		justifyContent: 'space-between',
		padding: isNewDashBoardEnabled ? '16px 16px 6px' : '17px 16px 10px 20px',
		display: 'flex !important',
		borderBottom: isNewDashBoardEnabled ? `1px solid ${grayColor[0]}` : 'none',
		[theme.breakpoints.down('xs')]: {
			paddingLeft: '30px',
		},
		'& p': {
			marginBottom: isNewDashBoardEnabled ? 0 : '10px',
		},
	}),
	dialogCloseButton: ({ isNewDashBoardEnabled }) => ({
		background: 'transparent',
		border: 'none',
		display: 'flex',
		padding: 0,
		alignItems: 'center',
		marginBottom: '7px',
		cursor: 'pointer',
		marginRight: 0,
		'& svg': {
			fontSize: '24px',
			color: isNewDashBoardEnabled ? blackColors[1] : blackColors[3],
		},
	}),
	buttonsWrapper: ({ isNewDashBoardEnabled }) => ({
		display: 'flex',
		justifyContent: isNewDashBoardEnabled ? 'flex-end' : 'space-between',
		padding: isNewDashBoardEnabled ? '16px' : '40px 40px 28px 40px',
		'& button:first-of-type': {
			marginRight: '8px',
		},
		borderTop: isNewDashBoardEnabled ? `1px solid ${grayColor[0]}` : 'none',
		[theme.breakpoints.down('xs')]: {
			padding: '20px 10px 28px 10px',
		},
	}),
	loadingWrapper: {
		position: 'absolute',
		left: 0,
		top: 0,
		width: '100%',
		height: '100%',
		display: 'flex',
		justifyContent: 'center',
		background: `rgba(${hexToRgb(whiteColor)}, 0.9)`,
		zIndex: 1000,
	},
	newThemeHeading: {
		fontWeight: 700,
	},
	closeButton: {
		position: 'absolute',
		right: 4,
		top: 0,
		color: blackColor,
	},
	statusHeading: {
		textAlign: 'center',
		paddingTop: '1rem',
	},
	statusBody: {
		height: '100%',
		padding: '2.5rem 0',

		'& p': {
			marginBottom: 0,
		},
	},
});

export default customDialogStyle;
